module.exports = __webpack_public_path__ + "img/platform.ebbd5664.svg";